import React from 'react';
import {withRouter} from "react-router-dom";
import {Button, Container, Header, Image, List} from "semantic-ui-react";
import {CustomContainer} from '../../custom-common';
import STRATEGIC_PARTNER from "../../../constants/strategicPartners";
import Footer from "../../footer";

const NewClaimSuccess = ({location: {claimNumber}, history}) => {

    const handleButtonClick = () => {
        history.replace("/claims");
    };

    return (
        <>
            <div className="member-main-container">
                <Container textAlign="center">
                    <CustomContainer padded="very" compact textAlign="center" style={{margin: '4em auto 1em auto', width: '460px'}}>
                        <Image centered style={{width: '70px'}}
                               src="https://brella-platform-assets.s3.amazonaws.com/enrollment/images/success.svg"/>
                        <Header as="h3">Thanks for filing your claim</Header>
                        <p>Your claim <b>{!!claimNumber ? `(${claimNumber})` : null}</b> will be reviewed by
                            the {STRATEGIC_PARTNER.LABEL} team within 24 hours.</p>
                        <CustomContainer basic textAlign="left">
                            <div className="pineGreenHeader">Next steps:</div>
                            <List ordered relaxed={"very"}>
                                <List.Item className="smaller">If your claim is approved, we’ll pay it in less than 72
                                    hours.</List.Item>
                                <List.Item className="smaller">Otherwise, our friendly concierge team will be in touch
                                    within 24 hours.</List.Item>
                            </List>
                        </CustomContainer>
                        <Button primary onClick={handleButtonClick}>All done</Button>
                    </CustomContainer>
                </Container>
            </div>
            <Footer hasToDisplayCarrierDisclaimer/>
        </>
    );
};

export default withRouter(NewClaimSuccess);
